import {
  Box,
  Card as MuiCard,
  CardContent,
  CircularProgress as MuiCircularProgress,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import { spacing } from "@mui/system";
import CurrencyTextField from "../../../../components/Inputs/CurrencyTextField";
// Redux Components
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { getAllPropertyPreviews } from "../../../../modules/apl/api/actions";
import {
  getAllUnsettledPropertyMeterReadingsByPropertyUUID,
  handleBillingProcessSubmission,
  updateBillingWizardBillInProgress,
  updateBillingWizardSelectedProperty,
} from "../../../../modules/billing/api/actions";
// Custom UI componets and functions:
import AdditionalBillLineItemsManager from "../../../../modules/billing/components/AdditionalBillLineIItemsChart";
import { logout } from "../../../../modules/user/api/actions";
import { formatMoney, txtBoxDateFormatter } from "../../../../setup/helpers";

const CenteredContent = styled.div`
  text-align: center;
`;

const CircularProgress = styled(MuiCircularProgress)(spacing);
const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);
const FormControl = styled(MuiFormControl)(spacing);
const TextField = styled(MuiTextField)(spacing);
const SpacedCurrencyTextField = styled(CurrencyTextField)(spacing);

// Custom Styles for property selection drop down

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  loadingIcon: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  typography: {
    flexGrow: 1,
    textAlign: "center",
  },
}));

const VendorInformationForm = (props) => {
  const vendorInformation =
    props.billing.data.billInProgress.vendorInformation;

  // Handles vendor drop down
  const [vendor, setVendor] = React.useState(vendorInformation.vendorID);
  const [fiscalMonth, setFiscalMonth] = React.useState(
    vendorInformation.fiscalMonth
  );
  const [vendorFormObject, setVendorFormObject] =
    React.useState(vendorInformation);
  // Bumps after server refresh so uncontrolled currency fields remount with new defaults
  const [currencyFieldsKey, setCurrencyFieldsKey] = React.useState(0);

  const [currentBillTotal, setBillTotal] = React.useState(
    vendorInformation.billTotal
  );
  const [currentCostPerKWH, setCostPerKWH] = React.useState(
    vendorInformation.costPerKWH
  );

  // After trial billing refresh, Redux replaces vendorInformation — resync local
  // uncontrolled field defaults without fighting in-place keystroke mutations
  // (those keep the same object reference).
  React.useEffect(() => {
    setVendorFormObject(vendorInformation);
    setVendor(vendorInformation.vendorID);
    setFiscalMonth(vendorInformation.fiscalMonth);
    setBillTotal(vendorInformation.billTotal);
    setCostPerKWH(vendorInformation.costPerKWH);
    setCurrencyFieldsKey((key) => key + 1);
  }, [vendorInformation]);

  const handleSelectedVendorChange = (event) => {
    setVendor(event.target.value);
    onFieldChange(event);
  };

  const onFiscalMonthFieldChange = (event) => {
    setFiscalMonth(event.target.value);
    onFieldChange(event);
  };
  const classes = useStyles();

  // Updates the local state object of "bill in progress" upon each modification
  const onFieldChange = (event) => {
    // Gets the current vendor info data and updates it with the event's name and value:
    if (event.target.type == "number") {
      props.billing.data.billInProgress.vendorInformation[event.target.name] =
        Number(event.target.value);
    } else if (event.target.id && event.target.id.includes("totalField_")) {
      var value = event.target.value;
      // CurrencyTextField may pass a number (outputFormat="number") or a string
      if (typeof value === "string") {
        value = value.replace(/\,/g, "");
        value = parseFloat(value);
      } else {
        value = Number(value);
      }
      if (!Number.isFinite(value)) {
        value = 0;
      }
      props.billing.data.billInProgress.vendorInformation[event.target.name] =
        value;
    } else {
      props.billing.data.billInProgress.vendorInformation[event.target.name] =
        event.target.value;
    }

    var billTotal = 0;
    var costPerKWH = 0;
    var kwhTotal =
      props.billing.data.billInProgress.vendorInformation.kwhUsedTotal;

    billTotal =
      billTotal +
      props.billing.data.billInProgress.vendorInformation.marketRateTotal +
      props.billing.data.billInProgress.vendorInformation.tariffRateTotal;
    if (billTotal == 0) {
      costPerKWH = 0;
    } else {
      costPerKWH = billTotal / kwhTotal;
    }

    props.billing.data.billInProgress.vendorInformation.billTotal = billTotal;
    props.billing.data.billInProgress.vendorInformation.costPerKWH = costPerKWH;
    setBillTotal(billTotal);
    setCostPerKWH(costPerKWH);
    // Replaces existing store object with new object with modified sub data
    //setVendorFormObject( vendorFormObject );
    // if (
    //   billTotal > 0 &&
    //   props.billing.data.billInProgress.currentStep < 2 &&
    //   props.billing.data.billInProgress.vendorInformation.vendorID != null
    // ) {
    //   props.billing.data.billInProgress.currentStep = 2;
    //   props.updateBillingWizardBillInProgress(
    //     props.billing.data.billInProgress
    //   );
    // } else if (
    //   billTotal <= 0 &&
    //   props.billing.data.billInProgress.currentStep >= 2
    // ) {
    //   props.billing.data.billInProgress.currentStep = 1;
    //   props.updateBillingWizardBillInProgress(
    //     props.billing.data.billInProgress
    //   );
    // }
  };

  const HandleTextBoxDisselect = (event) => {
    // props.handleBillingProcessSubmission(
    //   props.billing.data.billInProgress,
    //   false
    // );
    console.log("onBlur")
  };

  var billTotal = 0;
  var costPerKWH = 0;
  billTotal =
    billTotal +
    props.billing.data.billInProgress.vendorInformation.marketRateTotal +
    props.billing.data.billInProgress.vendorInformation.tariffRateTotal;
  if (props.billing.data.billInProgress.vendorInformation.kwhUsedTotal > 0) {
    costPerKWH =
      billTotal /
      props.billing.data.billInProgress.vendorInformation.kwhUsedTotal;
  }
  props.billing.data.billInProgress.vendorInformation.billTotal = billTotal;
  props.billing.data.billInProgress.vendorInformation.costPerKWH = costPerKWH;
  const selectedVendorId = vendorFormObject.vendorID;
  const activeVendors = props.vendors.data.vendorsList.items.filter(
    (item) =>
      !item.status ||
      item.status === "Active" ||
      item.id === selectedVendorId
  );
  return (
    <Card mb={6} elevation={3}>
      <CardContent>
        {/* Main Grid */}
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 3,
          width: '100%',
          mb: 3,
          alignItems: 'flex-start',
          justifyContent: 'flex-start'
        }}>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <FormControl fullWidth my={2}>
              <InputLabel id="vendorIDDropDownLabel">
                Vendor
                {props.vendors.isLoading && (
                  <CircularProgress size={15} m={0} />
                )}
              </InputLabel>
              {vendor == "" && props.vendors.isLoading ? (
                <Select
                  labelId="vendorIDDropDownLabel"
                  id="vendorID"
                  name="vendorID"
                  className={classes.selectedPropertyLocationLabel}
                  onChange={handleSelectedVendorChange}
                  onBlur={HandleTextBoxDisselect}
                  fullWidth
                  disabled
                  my={2}
                ></Select>
              ) : (
                <Select
                  labelId="vendorIDDropDownLabel"
                  id="vendorID"
                  name="vendorID"
                  defaultValue={vendorFormObject.vendorID}
                  className={classes.selectedPropertyLocationLabel}
                  onChange={handleSelectedVendorChange}
                  onBlur={HandleTextBoxDisselect}
                  fullWidth
                  my={2}
                >
                  {activeVendors.length > 0 ? [
                    activeVendors.map((item, key) => {
                      return (
                        <MenuItem value={item.id} id={key}>
                          {item.name}
                        </MenuItem>
                      );
                    })
                  ] : [
                    <MenuItem value={-1}>No Vendors Found</MenuItem>
                  ]}
                </Select>
              )}
            </FormControl>
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <FormControl fullWidth my={2}>
              <InputLabel id="fiscalMonthDropDownLabel">
                Fiscal Month (MM)
              </InputLabel>
              <Select
                labelId="fiscalMonthDropDownLabel"
                id="fiscalMonth"
                name="fiscalMonth"
                label="Fiscal Month (MM)"
                defaultValue={fiscalMonth}
                autoComplete={"off"}
                onChange={onFiscalMonthFieldChange}
                onBlur={HandleTextBoxDisselect}
                fullWidth
                my={2}
              >
                {[
                  <MenuItem value={1}>January</MenuItem>,
                  <MenuItem value={2}>February</MenuItem>,
                  <MenuItem value={3}>March</MenuItem>,
                  <MenuItem value={4}>April</MenuItem>,
                  <MenuItem value={5}>May</MenuItem>,
                  <MenuItem value={6}>June</MenuItem>,
                  <MenuItem value={7}>July</MenuItem>,
                  <MenuItem value={8}>August</MenuItem>,
                  <MenuItem value={9}>September</MenuItem>,
                  <MenuItem value={10}>October</MenuItem>,
                  <MenuItem value={11}>November</MenuItem>,
                  <MenuItem value={12}>December</MenuItem>
                ]}
              </Select>
            </FormControl>
            {/* <TextField
                        id="fiscalMonth"
                        label="Fiscal Month (MM)"
                        type="number"
                        fullWidth
                        my={2}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        defaultValue={(vendorFormObject.fiscalMonth != 0)&&
                            Number(vendorFormObject.fiscalMonth)
                        }
                        onChange={onFieldChange}
                        onBlur={HandleTextBoxDisselect}
                        name="fiscalMonth"
                        />
                    */}
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <TextField
              id="fiscalYear"
              label="Fiscal Year (YYYY)"
              type="number"
              autoComplete={"off"}
              fullWidth
              my={2}
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              defaultValue={
                vendorFormObject.fiscalYear != 0 && vendorFormObject.fiscalYear
              }
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              name="fiscalYear"
            />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <TextField
              id="billDate"
              label="Bill Date"
              type="date"
              fullWidth
              my={2}
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              defaultValue={txtBoxDateFormatter(vendorFormObject.billDate)}
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              name="billDate"
            />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <TextField
              id="meterReadDate"
              label="Meter Read Date"
              type="date"
              fullWidth
              my={2}
              variant="outlined"
              slotProps={{ inputLabel: { shrink: true } }}
              defaultValue={txtBoxDateFormatter(vendorFormObject.meterReadDate)}
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              name="meterReadDate"
            />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <SpacedCurrencyTextField
              key={`tariffRateTotal-${currencyFieldsKey}`}
              id="totalField_tariffRateTotal"
              label="Tarrif Rate Total (USD)"
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              name="tariffRateTotal"
              variant="standard"
              defaultValue={vendorFormObject.tariffRateTotal}
              currencySymbol="$"
              outputFormat="number"
              decimalCharacter="."
              digitGroupSeparator=","
              autoComplete={"off"}
              minimumValue="0"
              fullWidth
              my={2}
            />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <SpacedCurrencyTextField
              key={`marketRateTotal-${currencyFieldsKey}`}
              id="totalField_marketRateTotal"
              label="Market Rate Total (USD)"
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              autoComplete={"off"}
              name="marketRateTotal"
              variant="standard"
              defaultValue={vendorFormObject.marketRateTotal}
              currencySymbol="$"
              outputFormat="number"
              decimalCharacter="."
              digitGroupSeparator=","
              minimumValue="0"
              fullWidth
              my={2}
            />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <TextField
              my={2}
              fullWidth
              type="number"
              id="kwhUsedTotal"
              autoComplete={"off"}
              label="KWH Used Total"
              defaultValue={vendorFormObject.kwhUsedTotal}
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              name="kwhUsedTotal"
            />
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(33.33% - 16px)' } }}>
            <TextField
              my={2}
              fullWidth
              type="number"
              id="kwhTotal"
              autoComplete={"off"}
              label="KW Total"
              defaultValue={vendorFormObject.kwhTotal}
              onChange={onFieldChange}
              onBlur={HandleTextBoxDisselect}
              name="kwhTotal"
            />
          </Box>
        </Box>
        {/*Bottom of the page grid with additional line items*/}
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 3,
          width: '100%',
          mb: 3,
          alignItems: 'flex-start',
          justifyContent: 'flex-start'
        }}>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 12px)' } }}>
            <Typography variant="h5" className={classes.typography}>
              Bill Total: {formatMoney(billTotal)}
            </Typography>
          </Box>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 calc(50% - 12px)' } }}>
            <Typography variant="h5" className={classes.typography}>
              Cost / KWH: $ {(costPerKWH.toFixed(4) || 0)}
            </Typography>
          </Box>
          <Box sx={{ width: '100%' }}>
            <Divider className="mb-2 mt-2" my={1} />
          </Box>
          <Box sx={{ width: '100%' }}>
            <AdditionalBillLineItemsManager props={props} />
          </Box>
          {/*props.billing.data.billInProgress.currentStep == 1 &&
              <Box sx={{ width: '100%' }}>
                <Button mr={1} variant="contained" color="secondary" fullWidth onClick={()=>{
                  props.updateBillingWizardBillInProgress(props.billing.data.billInProgress.currentStep);
                  props.handleBillingProcessSubmission(props.billing.data.billInProgress);
                  }} my={2}>Save And Continue</Button>
              </Box>
                */}
        </Box>
      </CardContent>
    </Card>
  );
};

// Component Properties
VendorInformationForm.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  vendors: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  // Store object functions:
  getAllPropertyPreviews: PropTypes.func.isRequired,
  updateBillingWizardSelectedProperty: PropTypes.func.isRequired,
  updateBillingWizardBillInProgress: PropTypes.func.isRequired,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID: PropTypes.func.isRequired,
  handleBillingProcessSubmission: PropTypes.func.isRequired,
};

// Component State
function VendorInformationFormState(state) {
  return {
    user: state.user,
    vendors: state.vendors,
    billing: state.billing,
  };
}
export default connect(VendorInformationFormState, {
  logout,
  updateBillingWizardSelectedProperty,
  handleBillingProcessSubmission,
  updateBillingWizardBillInProgress,
  getAllPropertyPreviews,
  getAllUnsettledPropertyMeterReadingsByPropertyUUID,
})(VendorInformationForm);

//export default VendorInformationForm;
